import _ from "lodash";
import React, {useState} from "react";
import EditFontDetails from "./edit-font-details";
import EditColorDetails from "./edit-color-details";
import QuoteSettings from "./quote-settings";
import {processColorDetails} from "../common/utils/color-util";
import EditStrokeDetails from "./edit-stroke-details";
import {DEFAULT_EDITOR_TAB, EDITOR_TABS_LIST} from "../common/constants/quote.constant";
import EditorTabs from "./editor-tabs";
import ImageSidebar from "./image/image-sidebar";

const EditQuoteDetail = ({
                             quote,
                             setQuote,
                             selectedDisplayText,
                             handleSelectedDisplayTextTab,
                             setSelectedDisplayText,
                             handleQuoteSettingsChanges,
                             handleQuoteDisplayTextChanges,
                             isSettingSelected,
                             setIsSettingSelected,
                             setSelectedImage
                         }) => {
    const [selectedTab, setSelectedTab] = useState(DEFAULT_EDITOR_TAB);

    const handleColorAndFontDetailsChanges = (event: { target: { name: any; value: any; type: any; }; }) => {
        const {name, value, type} = event.target;
        const existingQuote = {...quote};

        const currentDisplayTextItems = existingQuote.displayTextItems;
        const currentIndex = _.findIndex(currentDisplayTextItems, ['itemKey', selectedDisplayText.itemKey]);

        const currentDisplayText = currentDisplayTextItems[currentIndex];

        if (type === 'number') {
            currentDisplayText[name] = parseInt(value);
        } else if (name && value) {
            currentDisplayText[name] = value;
        }

        processColorDetails(currentDisplayText);

        currentDisplayTextItems[currentIndex] = currentDisplayText;

        existingQuote.displayTextItems = currentDisplayTextItems;
        setSelectedDisplayText(currentDisplayText);
        setQuote(existingQuote);
        setIsSettingSelected(false);
    }

    const handleSelectDisplayText = (textItem) => {
        setIsSettingSelected(false);
        handleSelectedDisplayTextTab(textItem);
    }

    const handleSelectSettings = (event) => {
        setSelectedDisplayText(null);
        setIsSettingSelected(true);
        handleQuoteSettingsChanges(event);
    }

    return (
        <>
            <div className="mt-4 overflow-hidden">

                <div>
                    <EditorTabs selectedTab={selectedTab}
                                setSelectedTab={setSelectedTab}/>
                </div>

                {selectedTab === 'text' &&

                    <>
                        <div className="mt-2 flex justify-between items-start">
                            <div className="flex flex-wrap justify-start items-start">
                                {quote?.displayTextItems?.map((textItem, index) => (
                                    <div key={index} className="m-1">
                                        <button
                                            onClick={() => {
                                                handleSelectDisplayText(textItem)
                                            }}
                                            className={`content-text-tab ${textItem.itemKey === selectedDisplayText?.itemKey ? 'content-text-tab-selected' : ''}`}>
                                            <div className="mx-2">{textItem.text}</div>
                                        </button>
                                    </div>
                                ))}
                            </div>

                            <div className="m-1 float-right">
                                <button
                                    onClick={handleSelectSettings}
                                    className={`content-text-tab ${isSettingSelected ? 'content-text-tab-selected' : ''}`}>
                                    <div className="mx-2">Settings</div>
                                </button>
                            </div>
                        </div>

                        <div className="bg-gray-50 border border-gray-300 rounded p-6 mt-4 overflow-scroll">
                            {!isSettingSelected &&
                                <>
                                    <div className="">
                                        <EditFontDetails displayTextItem={selectedDisplayText}
                                                         handleFontDetailsChanges={handleColorAndFontDetailsChanges}/>
                                    </div>

                                    <div className="mt-4">
                                        <EditColorDetails displayTextItem={selectedDisplayText}
                                                          handleColorDetailsChanges={handleColorAndFontDetailsChanges}/>
                                    </div>

                                    <div className="mt-4">
                                        <EditStrokeDetails parentForm={selectedDisplayText}
                                                           handleStrokeDetailsChanges={handleColorAndFontDetailsChanges}/>
                                    </div>
                                </>
                            }

                            {isSettingSelected &&
                                <QuoteSettings quote={quote}
                                               handleQuoteSettingsChanges={handleSelectSettings}
                                               handleQuoteDisplayTextChanges={handleQuoteDisplayTextChanges}
                                />
                            }
                        </div>
                    </>

                }

                {selectedTab === 'image' &&
                    <>
                        <ImageSidebar setSelectedImage={setSelectedImage}/>
                    </>
                }

            </div>
        </>
    )
}

export default EditQuoteDetail
